import { render } from "./TypingMessage.vue?vue&type=template&id=13b4f179&scoped=true"
import script from "./TypingMessage.vue?vue&type=script&lang=js"
export * from "./TypingMessage.vue?vue&type=script&lang=js"

import "./TypingMessage.vue?vue&type=style&index=0&id=13b4f179&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b4f179"]])

export default __exports__